import { FlatItem } from 'src/types/elements.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/vehicle-types';

export const getVehicleTypesDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};
